
const selectorsCommonEN = {
  "selectors_clear": "All",
  "selectors_orderAkpacaType_all": "All",
  "selectors_orderAkpacaType_akpacaOnly": "Rush only",
  "selectors_orderAkpacaType_regular": "Regular",
}

const selectorsPlaceholdersEN = {
  "selectors_grower_placeholder": "Select grower",
  "selectors_car_placeholder": "Select car",
  "selectors_warehouse_placeholder": "Select warehouse",
  "selectors_teudaType_placeholder": "Select document type",
  "selectors_orderAkpacaType_placeholder": "Select order type",
  "selectors_product_placeholder": "Select product",
  "selectors_size_placeholder": "Select size",
  "selectors_package_placeholder": "Select package",
  "selectors_palletType_placeholder": "Select pallet",
  "selectors_report_placeholder": "Select report",
}

const selectorsEmptyEN = {
  "selectors_grower_empty": "No matching growers",
  "selectors_car_empty": "No matching cars",
  "selectors_warehouse_empty": "No matching warehouses",
  "selectors_teudaType_empty": "No matching types",
  "selectors_product_empty": "No matching products",
  "selectors_size_empty": "No matching sizes",
  "selectors_package_empty": "No matching packages",
  "selectors_palletType_empty": "No matching pallets",
  "selectors_report_empty": "No matching reports",
  "selectors_location_empty": "No matching locations",
}

export const selectorsTranslationEN = {
  selectors: {
    ...selectorsCommonEN,
    ...selectorsPlaceholdersEN,
    ...selectorsEmptyEN,
  }
}
